import { ImprovedParticipant } from "../../../Interfaces/FundraiserRole";

const participant: ImprovedParticipant = {
  id: 2321,
  first_name: "Ethan",
  last_name: "Caldwell",
  full_name: "Ethan Caldwell",
  participant_code: "FAKE123",
  current_profit: 648,
  current_goal: 75,
  supporter_count: 4,
  profile_image_url: null,
  primary_division: {
    id: 724,
    fundraiser: 116,
    primary_division: null,
    search_name: "juniors_bb",
    display_name: "Juniors BB",
  },
  secondary_division: {
    id: 725,
    fundraiser: 116,
    primary_division: 724,
    search_name: "braves",
    display_name: "Braves",
  },
  fundraiser: 116,
  fundraiser_name: "Sample Fundraiser",
  account_profile_id: 2232,
  has_boughtout: false,
  buyout: 0,
  fundraiser_end_date: "2026-04-09",
};

export default participant;
